chatClient.directive('chatClient', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'chat_client/templates/' + helperService.getRedesignPathPrefix() + 'chatClient.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
